import { useReducer } from 'react'

import useValidation from './useValidation'

const reducer = (state, action) => {
  switch (action.type) {
  case 'setFieldValue':
    return { ...state, [action.field]: action.value }
  default:
    throw new Error('Invalid reducer action')
  }
}

const useTribute = ({ i18n, tribute, order }) => {
  const [ state, dispatch ] = useReducer(reducer, {
    enabled: !!order.honoree_name,
    honoree_name: order.honoree_name || '',
    tribute_type: tribute.tribute_types[0],
    has_recipient: false,
    given_by: '',
    recipient_name: '',
    recipient_email: '',
    recipient_message: '',
  })

  const fieldSet = {}

  if (tribute.hide_recipient_send) {
    fieldSet.honoree_name = { maxLength: 60 }
  } else if (state.enabled) {
    fieldSet.honoree_name = { required: true, maxLength: 60 }

    if (state.has_recipient) {
      fieldSet.given_by = { required: true, maxLength: 60 }
      fieldSet.recipient_name = { required: true, maxLength: 60 }
      fieldSet.recipient_email = { required: true, maxLength: 75, email: true }
      fieldSet.recipient_message = { maxLength: 2000 }
    }
  }

  const validation = useValidation({ i18n, fieldSet })

  const validate = () => validation.validate(state)

  const inputProps = id => ({
    id: `tribute_${id}`,
    value: state[id],
    error: validation.errors?.[id]?.[0],
    onChange (e) {
      dispatch({ type: 'setFieldValue', field: id, value: e.target.value })
    },
  })

  const booleanProps = id => ({
    id: `tribute_${id}`,
    checked: state[id],
    onChange (e) {
      dispatch({ type: 'setFieldValue', field: id, value: e.target.checked })
    },
  })

  const draftOrderProps = () => {
    const { enabled, ...tribute_attributes } = state
    return (tribute.hide_recipient_send ? state.honoree_name.trim() : enabled)
    ? { tribute_attributes }
    : { tribute_attributes: { _destroy: true } }
  }

  return {
    ...tribute, state, validate, inputProps, booleanProps, draftOrderProps,
  }
}

export default useTribute
